import React from "react";

export interface WorkspaceOverviewProps {
	workspaceId: string;
	session?: any;
	currentWorkspace?: any;
}

export const WorkspaceOverview: React.FC<WorkspaceOverviewProps> = ({
	workspaceId,
	session,
	currentWorkspace,
}) => {
	return (
		<div className="flex h-full flex-col items-center justify-center bg-background p-8 text-foreground">
			<h1 className="mb-2 font-bold text-2xl">
				Welcome to {currentWorkspace?.name || "Workspace"}
			</h1>
			<p className="text-muted-foreground">
				Workspace ID: <span className="font-mono">{workspaceId}</span>
			</p>
			<p className="mt-4 text-muted-foreground text-sm">
				Select a section from the sidebar to get started
			</p>
		</div>
	);
};